var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidelines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6339 14.1161C35.122 14.6043 35.122 15.3957 34.6339 15.8839L27.7589 22.7589C27.2707 23.247 26.4793 23.247 25.9911 22.7589C25.503 22.2707 25.503 21.4793 25.9911 20.9911L32.8661 14.1161C33.3543 13.628 34.1457 13.628 34.6339 14.1161Z",
    fill: "#25A249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2411 15.9911C17.7293 15.503 18.5207 15.503 19.0089 15.9911L24.0089 20.9911C24.497 21.4793 24.497 22.2707 24.0089 22.7589C23.5207 23.247 22.7293 23.247 22.2411 22.7589L17.2411 17.7589C16.753 17.2707 16.753 16.4793 17.2411 15.9911Z",
    fill: "#25A249"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2589 15.9911C15.747 16.4793 15.747 17.2707 15.2589 17.7589L7.13388 25.8839C6.64573 26.372 5.85427 26.372 5.36612 25.8839C4.87796 25.3957 4.87796 24.6043 5.36612 24.1161L13.4911 15.9911C13.9793 15.503 14.7707 15.503 15.2589 15.9911Z",
    fill: "#25A249"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.625 12.5C35.2798 12.5 35 12.7798 35 13.125C35 13.4702 35.2798 13.75 35.625 13.75C35.9702 13.75 36.25 13.4702 36.25 13.125C36.25 12.7798 35.9702 12.5 35.625 12.5ZM32.5 13.125C32.5 11.3991 33.8991 10 35.625 10C37.3509 10 38.75 11.3991 38.75 13.125C38.75 14.8509 37.3509 16.25 35.625 16.25C33.8991 16.25 32.5 14.8509 32.5 13.125Z",
    fill: "#25A249"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 23.125C24.6548 23.125 24.375 23.4048 24.375 23.75C24.375 24.0952 24.6548 24.375 25 24.375C25.3452 24.375 25.625 24.0952 25.625 23.75C25.625 23.4048 25.3452 23.125 25 23.125ZM21.875 23.75C21.875 22.0241 23.2741 20.625 25 20.625C26.7259 20.625 28.125 22.0241 28.125 23.75C28.125 25.4759 26.7259 26.875 25 26.875C23.2741 26.875 21.875 25.4759 21.875 23.75Z",
    fill: "#25A249"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 14.375C15.9048 14.375 15.625 14.6548 15.625 15C15.625 15.3452 15.9048 15.625 16.25 15.625C16.5952 15.625 16.875 15.3452 16.875 15C16.875 14.6548 16.5952 14.375 16.25 14.375ZM13.125 15C13.125 13.2741 14.5241 11.875 16.25 11.875C17.9759 11.875 19.375 13.2741 19.375 15C19.375 16.7259 17.9759 18.125 16.25 18.125C14.5241 18.125 13.125 16.7259 13.125 15Z",
    fill: "#25A249"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 26.25C4.02982 26.25 3.75 26.5298 3.75 26.875C3.75 27.2202 4.02982 27.5 4.375 27.5C4.72018 27.5 5 27.2202 5 26.875C5 26.5298 4.72018 26.25 4.375 26.25ZM1.25 26.875C1.25 25.1491 2.64911 23.75 4.375 23.75C6.10089 23.75 7.5 25.1491 7.5 26.875C7.5 28.6009 6.10089 30 4.375 30C2.64911 30 1.25 28.6009 1.25 26.875Z",
    fill: "#25A249"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelines);
export default __webpack_public_path__ + "static/media/guidelines.ab86bea68b512b28133320dcc6f361a8.svg";
export { ForwardRef as ReactComponent };